// Shared file input helpers to keep components lean

export const triggerFileInput = (inputEl) => {
  if (inputEl && typeof inputEl.click === 'function') {
    inputEl.click();
  }
};

export const getSelectedFileAndReset = (event) => {
  const file = event?.target?.files?.[0] || null;
  if (event?.target) {
    // reset so selecting the same file twice still triggers change
    event.target.value = '';
  }
  return file;
};
